module.exports = __webpack_public_path__ + "static/the-book-of-joy-079ad54d5251be8cfa11fb5fe963abcb.jpg";